<!-- 核心结果 -->
<template>
    <div class="page_part5">
        <div class="page_shadow page_main">
            <TopHeader :title="'核心结果总览'" :headerLogo="headerLogo"></TopHeader>
            <h5 class="header page_header">
                <span>Part.1 核心结果</span>
            </h5>
            <h6 class="page_title_2">
                <span>核心结果总览</span>
                <span class="arrow"></span>
            </h6>
            <p class="page_title_3_0">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习力总体得分
            </p>
            <p class="part_detail">
                你的学习力总体得分为：<span :class="getCorlor(total.score)">{{total.score | toFixed(1)}}</span>分，
                整体水平为：<span :class="getCorlor(total.score)">{{getGrade(total.score)}}</span>，
                超过<span :class="getCorlor(total.score)">{{total.percent*100 | toFixed(1)}}%</span>的人。
            </p>
            <div class="lis_score_box  psychology" :style="{width: '712px',marginLeft: '-10px'}">
                <ul class="lis_score lis_psy">
                    <li>
                        <p class="name">
                            {{total.name}}
                        </p>
                        <div class="li_score_box">
                            <div class="box">
                                <div class="score"  :class=[getBgColor1(total.score)] :style="{width: total.score/200*600 + 'px'}" >
                                </div>
                                <p  class="comment"  :style="{left: total.score/200*600-40 + 'px'}">
                                    <span>{{total.score | toFixed(1)}}</span>
                                    <span :class="getCorlor(total.score)">[{{getGrade(total.score)}}]</span>
                                </p>
                                <div class="norm"  :style="{left: normData.l_norm/200*600 + 'px', width: (normData.r_norm-normData.l_norm)/200*600 + 'px'}">
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <p class="name">
                            {{part1Total.name}}
                        </p>
                        <div class="li_score_box">
                            <div class="box">
                                <div class="score"  :class=[getBgColor1(part1Total.score)] :style="{width: part1Total.score/200*600 + 'px'}" >
                                    <!--                                    <p>-->
                                    <!--                                        <span>{{part1Total.score | toFixed(1)}}</span>-->
                                    <!--                                        <span :class="getCorlor(part1Total.score)">[{{getGrade(part1Total.score)}}]</span>-->
                                    <!--                                    </p>-->
                                </div>
                                <p  class="comment"  :style="{left: part1Total.score/200*600-40 + 'px'}">
                                    <span>{{part1Total.score | toFixed(1)}}</span>
                                    <span :class="getCorlor(part1Total.score)">[{{getGrade(part1Total.score)}}]</span>
                                </p>
                                <div class="norm"  :style="{left: normData.l_norm/200*600 + 'px', width: (normData.r_norm-normData.l_norm)/200*600 + 'px'}">
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <p class="name">
                            {{part3Total.name}}
                        </p>
                        <div class="li_score_box">
                            <div class="box">
                                <div class="score"  :class=[getBgColor1(part3Total.score)] :style="{width: part3Total.score/200*600 + 'px'}" >
                                    <!--                                    <p>-->
                                    <!--                                        <span>{{part3Total.score | toFixed(1)}}</span>-->
                                    <!--                                        <span :class="getCorlor(part3Total.score)">[{{getGrade(part3Total.score)}}]</span>-->
                                    <!--                                    </p>-->
                                </div>
                                <p  class="comment"  :style="{left: part3Total.score/200*600-40 + 'px'}">
                                    <span>{{part3Total.score | toFixed(1)}}</span>
                                    <span :class="getCorlor(part3Total.score)">[{{getGrade(part3Total.score)}}]</span>
                                </p>
                                <div class="norm"  :style="{left: normData.l_norm/200*600 + 'px', width: (normData.r_norm-normData.l_norm)/200*600 + 'px'}">
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <p class="name">
                            {{part2Total.name}}
                        </p>
                        <div class="li_score_box">
                            <div class="box">
                                <div class="score"  :class=[getBgColorDongli(part2Total.score)] :style="{width: part2Total.score/200*600 + 'px'}" >
                                    <!--                                    <p>-->
                                    <!--                                        <span>{{part2Total.score | toFixed(1)}}</span>-->
                                    <!--                                        <span :class="getCorlor(part2Total.score)">[{{getGrade(part2Total.score)}}]</span>-->
                                    <!--                                    </p>-->
                                </div>
                                <p  class="comment"  :style="{left: part2Total.score/200*600-40 + 'px'}">
                                    <span>{{part2Total.score | toFixed(1)}}</span>
                                    <span :class="getCorlorDongli(part2Total.score)">[{{getGradeDongli(part2Total.score)}}]</span>
                                </p>
                                <div class="norm"  :style="{left: normDataDongli.power_score.l_norm/200*600 + 'px', width: (normDataDongli.power_score.r_norm-normDataDongli.power_score.l_norm)/200*600 + 'px'}">
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="rule_box">
                    <p class="name"><span>0</span></p>
                    <ul class="rule">
                        <li v-for="item in [20,40,60,80,100,120,140,160,180,200]">
                            <span>{{item}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <p class="page_title_3_0">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习潜力得分
            </p>
            <p class="part_detail">
                你的{{part1Total.name}}总体得分为：<span :class="getCorlor(part1Total.score)">{{part1Total.score | toFixed(1)}}</span>分，
                整体水平为：<span :class="getCorlor(part1Total.score)">{{getGrade(part1Total.score)}}</span>，
                超过<span :class="getCorlor(part1Total.score)">{{part1Total.percent*100 | toFixed(1)}}%</span>的人。
            </p>
            <div class="echartsBox">
                <div class="normBox1"></div>
                <div id="echart_qianli" :style="{width: '710px',height: '450px'}"></div>
            </div>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <TopHeader :title="'核心结果总览'" :headerLogo="headerLogo"></TopHeader>
            <p class="page_title_3_0">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习效力-学习策略得分
            </p>
            <p class="part_detail">
                你的学习策略总体平均得分为：<span :class="getCorlor(part3Total.score)">{{part3Total.score | toFixed(1)}}</span>分，
                整体水平为：<span :class="getCorlor(part3Total.score)">{{getGrade(part3Total.score)}}</span>，
                超过<span :class="getCorlor(part3Total.score)">{{part3Total.percent*100 | toFixed(1)}}%</span>的人。
            </p>
            <div class="echartsBox" :style="{marginBottom: '40px'}">
                <div class="normBox1"></div>
                <div id="echart_celve" :style="{width: '710px',height: '450px'}"></div>
            </div>
            <p class="page_title_3_0">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习效力-学习风格得分
            </p>
            <div class="table_box">
                <table>
                    <tbody>
                    <tr>
                        <th class="th_1">依<br/>存<br/>风<br/>格</th>
                        <td class="titleBox">
                            <p class="title">依存风格类型</p>
                            <p class="detail">{{comment2.name}}</p>
                        </td>
                        <td class="td_score_box">
                            <p class="title">依存风格偏向</p>
                            <div class="score_line_box">
                                <p class="score" :class="getScore(styleNorm2.score)">{{comment2.name}}</p>
                                <p class="td_p1">依存型</p>
                                <p class="td_p2">依存·独立型</p>
                                <p class="td_p3">独立型</p>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th class="th_2">决<br/>策<br/>风<br/>格</th>
                        <td class="titleBox">
                            <p class="title">决策风格类型</p>
                            <p class="detail">{{comment3.name}}</p>
                        </td>
                        <td class="td_score_box">
                            <p class="title">决策风格偏向</p>
                            <div class="score_line_box">
                                <p class="score" :class="getScore(styleNorm3.score)">{{comment3.name}}</p>
                                <p class="td_p1">冲动型</p>
                                <p class="td_p2">冲动·沉思型</p>
                                <p class="td_p3">沉思型</p>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th class="th_3">执<br/>行<br/>风<br/>格</th>
                        <td class="titleBox">
                            <p class="title">执行风格类型</p>
                            <p class="detail">{{comment1.name}}</p>
                        </td>
                        <td class="td_score_box">
                            <p class="title">执行风格偏向</p>
                            <div class="score_line_box">
                                <p class="score" :class="getScore(styleNorm1.score)">{{comment1.name}}</p>
                                <p class="td_p1">执行型</p>
                                <p class="td_p2">执行·创造型</p>
                                <p class="td_p3">创造型</p>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main page_fenxi">
            <TopHeader :title="'核心结果总览'" :headerLogo="headerLogo"></TopHeader>
            <p class="page_title_3_0">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习动力得分
            </p>
            <p class="part_detail">
                你的{{part2Total.name}}总体平均得分为：<span :class="getCorlorDongli(part2Total.score)">{{part2Total.score | toFixed(1)}}</span>分，
                整体水平为：<span :class="getCorlorDongli(part2Total.score)">{{getGradeDongli(part2Total.score)}}</span>。
            </p>
            <div class="page_part2_result page_part5_result">
                <div :class="['detail_box','detail_box'+index]" v-for="(item,index) in part2norm" :key="index" v-if="index < 3">
                    <p class="title"><span></span>{{item.name}}</p>
                    <p class="score">水平值：<span>{{item.score | toFixed(1)}}</span></p>
                    <p class="score">评价：<span>{{getGradeDongli(item.score)}}</span></p>
                    <!--<p class="norm">常模范围：<span>{{item.lnorm}}-{{item.rnorm}}</span></p>-->
                </div>
                <div class="circle_box">
                    <div class="topBox"></div>
                    <div class="middleBox">
                        <div :class="['norm_box','norm_' + item.type]" v-for="(item,index) in part2norm" :key="index" v-if="index < 3">
                            <div class="norm">
                                <div class="norm_child" v-if="item.type=='qinggan'"  :style="{left: (normDataDongli.qinggan.l_norm-1)/200*180 + 'px', width: (normDataDongli.qinggan.r_norm-normDataDongli.qinggan.l_norm)/200*180 + 'px' }"></div>
                                <div class="norm_child" v-if="item.type=='renzhi'"  :style="{left: (normDataDongli.renzhi.l_norm-1)/200*180 + 'px', width: (normDataDongli.renzhi.r_norm-normDataDongli.renzhi.l_norm)/200*180 + 'px' }"></div>
                                <div class="norm_child" v-if="item.type=='xingwei'"  :style="{left: (normDataDongli.xingwei.l_norm-1)/200*180 + 'px', width: (normDataDongli.xingwei.r_norm-normDataDongli.xingwei.l_norm)/200*180 + 'px' }"></div>
                                <div class="norm_bg"></div>
                                <div class="score" :style="{left: (item.score*180)/200-2.5 + 'px'}" :title="item.score | toFixed(1)"><span>{{item.score | toFixed(1)}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="bottomBox">
                        <p class="title"><span></span>学习动力</p>
                        <p class="score">水平值：<span>{{part2norm[3].score| toFixed(1)}}</span></p>
                        <p class="score">评价：<span>{{getGradeDongli(part2norm[3].score)}}</span></p>
                    </div>
                </div>
            </div>
            <p class="page_title_3_0">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                心理风险得分
            </p>
            <p class="part_detail">
                你的心理风险总体平均得分为：<span :style="{color: getCorlorGrade(part4norm.mind.score)}">{{part4norm.mind.score}}</span>分，
                整体水平为：<span :style="{color: getCorlorGrade(part4norm.mind.score)}">{{getGradeMind(part4norm.mind.score)}}</span>。
            </p>
            <div class="lis_score_box  psychology">
                <ul class="lis_score lis_psy">
                    <li v-for="(item,index) in part4normSort" :key="index">
                        <p class="name">
                            {{item.name}}
                        </p>
                        <div class="li_score_box">
                            <div class="box">
                                <div class="score"  :class=[getBgColor(item.name,item.score)] :style="{width: item.score/5*600 + 'px'}" >

                                </div>
                                <p class="score_comment" :style="{left: item.score/5*600-30 + 'px'}">{{item.score | toFixed(1)}}</p>
                                <div class="norm"  :style="{left: normDataMind[item.type].l_norm/5*600 + 'px', width: (normDataMind[item.type].r_norm-normDataMind[item.type].l_norm)/5*600 + 'px' }">
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="rule_box">
                    <p class="name"><span>0</span></p>
                    <ul class="rule">
                        <li v-for="item in 5">
                            <span>{{item}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main page_fenxi">
            <TopHeader :title="'核心结果分析'" :headerLogo="headerLogo"></TopHeader>
            <h6 class="page_title_2">
                <span>核心结果分析</span>
                <span class="arrow"></span>
            </h6>
            <div class="fenxi_box">
                <p class="f_title bg_blue">优势项</p>
                <div class="main" v-for="(item,index) in core.advantage" :key="index">
                    <template v-if="item.name">
                        <p class="title">{{item.name}}</p>
                        <p>{{item.content}}</p>
                    </template>
                    <template v-else>
                        <p class="title">{{item}}</p>
                    </template>
                </div>
            </div>
            <div class="fenxi_box">
                <p class="f_title bg_orange">待发展项</p>
                <div class="main" v-for="(item,index) in core.disadvantage" :key="index">
                    <template v-if="item.name">
                        <p class="title">{{item.name}}</p>
                        <p>{{item.content}}</p>
                    </template>
                    <template v-else>
                        <p class="title">{{item}}</p>
                    </template>
                </div>
            </div>
            <div class="fenxi_box">
                <p class="f_title bg_green">改进建议</p>
                <div class="main">
                    <p class="advise" v-if="Array.isArray(core.potentialImprove)">建议加强 <span v-for="(item,index) in core.potentialImprove" :key="index"><span v-show="index != 0">、</span>{{item}}</span> 的相关训练，注重日常有意识地练习和培养；</p>
                    <p class="advise" v-else>{{core.potentialImprove}}</p>

                    <p class="advise" v-if="Array.isArray(core.strategyImprove)">建议有意识地练习和掌握 <span v-for="(item,index) in core.strategyImprove" :key="index"><span v-show="index != 0">、</span>{{item}}</span>，优化学习过程，形成良好的学习习惯；</p>
                    <p class="advise" v-else>{{core.strategyImprove}}</p>

                    <p class="advise">{{part2comment[3].comment}}</p>
                </div>
            </div>
            <p class="big_page_number"></p>
        </div>
    </div>
</template>
<script>
import TopHeader from './TopHeader.vue';//页眉
// import ThePart5Main from './ThePart5Main.vue';//核心结果
export default {
    name: 'page_part5',
    components: {TopHeader},
    props: {
        headerLogo: {},
        core: {
        },
        normData: {
        },
        normDataDongli:{
        },
        normDataMind: {
        },
        partIndex: {
            type: Number
        },
        //学习力总体
        total: {
            type: Object
        },
        //学习潜力总体
        part1Total: {
            type: Object
        },
        //学习动力总体
        part2Total: {
            type: Object
        },
        //学习效力总体
        part3Total: {
            type: Object
        },
        part1Norm: {
        },
        part2norm: {
        },
        part2comment: {},
        part3StrategyNorm: {
        },
        part4norm: {
        },
        part4comment: {
        },

        strategyNorm: {
            type: Array
        },
        strategyComment: {
            type: Array
        },
        styleNorm: {
            type: Object
        },
        styleComment: {
            type: Object
        },
    },
    data() {
        return {
        }
    },
    computed: {
        part1NormSort() {
            let arr = [];
            let part1Norm = this.part1Norm;
            arr[0]=part1Norm[8];
            arr[1]=part1Norm[0];
            arr[2]=part1Norm[1];
            arr[3]=part1Norm[4];
            arr[4]=part1Norm[5];
            arr[5]=part1Norm[7];
            arr[6]=part1Norm[3];
            arr[7]=part1Norm[2];
            arr[8]=part1Norm[6];
            return arr;
        },
        part3StrategyNormSort() {
            let arr = [];
            let part3Norm = this.part3StrategyNorm;
            arr[0]=part3Norm[5];
            arr[1]=part3Norm[2];
            arr[2]=part3Norm[9];
            arr[3]=part3Norm[4];
            arr[4]=part3Norm[0];
            arr[5]=part3Norm[10];
            arr[6]=part3Norm[6];
            arr[7]=part3Norm[7];
            arr[8]=part3Norm[1];
            arr[9]=part3Norm[3];
            arr[10]=part3Norm[8];
            return arr;
        },
        part4normSort() {
            let arr = [];
            let norm = this.part4norm;
            arr[0] = norm.qiangpo;
            arr[1] = norm.mingan;
            arr[2] = norm.yiyu;
            arr[3] = norm.jiaolv;
            arr[4] = norm.didui;
            arr[5] = norm.pizhi;
            return arr;
        },
        styleNorm1() {
            return this.styleNorm.chuangxin;
        },
        styleNorm2() {
            return this.styleNorm.duli;
        },
        styleNorm3() {
            return this.styleNorm.chensi;
        },
        comment1() {
            return this.styleComment.chuangxin;
        },
        comment2() {
            return this.styleComment.duli;
        },
        comment3() {
            return this.styleComment.chensi;
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        let part1NormSort = this.part1NormSort;
        let part3StrategyNorm = this.part3StrategyNormSort;
        this.setEcharts(part1NormSort,'echart_qianli');
        this.setEcharts(part3StrategyNorm,'echart_celve');
    },
    methods: {
        getScore(value) {
            // 83.125,116.875
            if(value < 83.125) {
                return 'score1'
            }else if (value < 116.875) {
                return 'score2'
            }else {
                return 'score3'
            }
        },
        setEcharts(normData,id) {
            let xAxisData = [];
            let seriesData = [];
            let colorList = [];
            normData.forEach((value,index)=>{
                xAxisData.push(value.name);
                seriesData.push(Number(value.score.toFixed(1)));
                colorList.push(this.getEchartCorlor(value.score));
            })
            this.createEcharts(xAxisData,seriesData,colorList,id);
        },
        getEchartCorlor(value) {
            if(0<value&&value<75) {
                return '#FF0000'
            }else if (75<=value&&value<92){
                return '#FFC001'
            }else if (92<=value&&value<108){
                return '#1CA4B6'
            }else if (108<=value&&value<125){
                return '#92D050'
            }else{
                return '#00B050'
            }
        },
        getBgColor1(value) {
            if(0<value&&value<75) {
                return 'bg_color1'
            }else if (75<=value&&value<92){
                return 'bg_color2'
            }else if (92<=value&&value<108){
                return 'bg_color3'
            }else if (108<=value&&value<125){
                return 'bg_color4'
            }else{
                return 'bg_color5'
            }
        },
        getBgColor(name,value) {
            let normObj = {
                qiangpo: [0,1.38,2.82,3,4,5],
                renji: [0,1.04,2.5,3,4,5],
                yiyu: [0,1.06,2.48,3,4,5],
                jiaolv: [0,1.06,2.44,3,4,5],
                didui: [0,1.07,2.55,3,4,5],
                pianzhi: [0,1.06,2.42,3,4,5]
            }
            let normArr;
            if(name == '强迫症状') {
                normArr = normObj.qiangpo;
            }else if(name == '人际关系敏感') {
                normArr = normObj.renji;
            }else if(name == '抑郁') {
                normArr = normObj.yiyu;
            }else if(name == '焦虑') {
                normArr = normObj.jiaolv;
            }else if(name == '敌对') {
                normArr = normObj.didui;
            }else if(name == '偏执') {
                normArr = normObj.pianzhi;
            }

            if(normArr[0]<value&&value<normArr[1]) {
                return 'c_mind1'
            }else if (normArr[1]<=value&&value<normArr[2]){
                return 'c_mind2'
            }else if (normArr[2]<=value&&value<normArr[3]){
                return 'c_mind3'
            }else if (normArr[3]<=value&&value<normArr[4]){
                return 'c_mind4'
            }else{
                return 'c_mind5'
            }
        },
        getCorlorGrade(value) {
            // num1: 1.1
            // num2: 2.6
            // num3: 3
            // num4: 4
            if(value<1.1) {
                return '#00B050'
            }else if (value<2.6){
                return '#92D050'
            }else if (value<3){
                return '#F6A724'
            }else if (value<4){
                return '#FF0000'
            }else{
                return '#D50203'
            }
        },
        getCorlor(value) {
            if(0<value&&value<75) {
                return 'color1'
            }else if (75<=value&&value<92){
                return 'color2'
            }else if (92<=value&&value<108){
                return 'color3'
            }else if (108<=value&&value<125){
                return 'color4'
            }else{
                return 'color5'
            }
        },
        getCorlorDongli(value) {
            if(0<value&&value<40) {
                return 'color1'
            }else if (40<=value&&value<80){
                return 'color2'
            }else if (80<=value&&value<120){
                return 'color3'
            }else if (120<=value&&value<160){
                return 'color4'
            }else{
                return 'color5'
            }
        },
        getBgColorDongli(value) {
            if(0<value&&value<40) {
                return 'bg_color1'
            }else if (40<=value&&value<80){
                return 'bg_color2'
            }else if (80<=value&&value<120){
                return 'bg_color3'
            }else if (120<=value&&value<160){
                return 'bg_color4'
            }else{
                return 'bg_color5'
            }
        },
        getGradeDongli(value) {
            if(0<value&&value<40) {
                return '低'
            }else if (40<=value&&value<80){
                return '较低'
            }else if (80<=value&&value<120){
                return '中等'
            }else if (120<=value&&value<160){
                return '较高'
            }else{
                return '高'
            }
        },
        getGradeMind(value) {
            if(value<1.1) {
                return '低'
            }else if (value<2.6){
                return '较低'
            }else if (value<3){
                return '中等'
            }else if (value<4){
                return '较高'
            }else{
                return '高'
            }
        },
        getGrade(value) {
            if(0<value&&value<75) {
                return '低'
            }else if (75<=value&&value<92){
                return '较低'
            }else if (92<=value&&value<108){
                return '中等'
            }else if (108<=value&&value<125){
                return '较高'
            }else{
                return '高'
            }
        },
        createEcharts(xAxisData,seriesData,colorList,id) {
            // 基于准备好的dom，初始化echarts实例
            var myChart = this.$echarts.init(document.getElementById(id));
            // 指定图表的配置项和数据
            var option = {
                // title: {
                //     text: '分值'
                // },
                tooltip: {},
                // legend: {
                //     data:[]
                // },
                xAxis: {
                    type: 'category',
                    // data: ['注意力','信息加工能力','工作记忆能力','思维转换能力','逻辑推理能力','数学能力','表象能力','空间能力','语言能力'],
                    data: xAxisData,
                    axisLabel: {
                        // interval: 0,
                        rotate: 45,
                        color:'#333',
                    },
                },
                yAxis: {
                    max: 200,
                    splitNumber: 10,
                    // Interval: 1,
                    type: 'value',
                    name: '分值',

                },
                series: [{
                    name: '',
                    type: 'bar',
                    // data: [115,107,102,130,89,125,61,122,106],
                    data: seriesData,
                    itemStyle: {
                        normal: {
                            //这里是重点
                            color: function(params) {
                                // console.log(colorList)
                                //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                                // var colorList = ['#71B15B','#2E75B6', '#3E9B7C', '#ECAC5C'];
                                return colorList[params.dataIndex]
                            },
                            label: {
                                show: true, //开启显示
                                position: 'top', //在上方显示
                                textStyle: { //数值样式
                                    color: 'black',
                                    fontSize: 14
                                }
                            }
                        }
                    },
                    label: {
                        show: true,
                        color: '#fff',
                    }
                }],

                barCategoryGap: '60%',
                // color: '#2c8ffc'
            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }
    }
}
</script>
<style type="text/css" lang='less' scoped>
@import './report.less';
.page_part5 {
    .part_detail {
        line-height: 32px;
        margin-bottom: 20px;
        span {
            font-size: 18px;
            font-weight: bold;
        }
    }
    .echartsBox {
        position: relative;
        .normBox1 {
            position: absolute;
            width: 566px;
            height: 83px;
            left: 72px;
            bottom: 184px;
            background: rgba(121, 119, 119, 0.49);
            opacity: 0.5;
        }

    }
    .score_line_box {
        margin-top: 55px;
        display: flex;
        height: 20px;
        line-height: 20px;
        width: 480px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        position: relative;
        .score {
            //[83.125,116.875]
            position: absolute;
            top: -36px;
            margin-left: -40px;
            width: 80px;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            background-color: #FFB91A;
            color: #333;
            border-radius: 3px;
            &:before {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 50%;
                margin-left: -5px;
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 10px solid #FFB91A;
            }
        }
        .score1 {
            left: 80px;
            background-color: #AACF00;
            &:before {
                border-top: 10px solid #AACF00;
            }
        }
        .score2 {
            left: 240px;
            background-color: #F6A724;
            &:before {
                border-top: 10px solid #F6A724;
            }
        }
        .score3 {
            left: 400px;
            background-color: #2CABBB;
            &:before {
                border-top: 10px solid #2CABBB;
            }
        }
        .td_p1 {
            //83.125/200*480
            flex: 1;
            height: 20px;
            line-height: 20px;
            background-color: #AACF00;
            border-radius: 10px 0 0 10px;
        }
        .td_p2 {
            height: 20px;
            line-height: 20px;
            flex: 1;
            background-color: #F6A724;
        }
        .td_p3 {
            height: 20px;
            line-height: 20px;
            flex: 1;
            background-color: #2CABBB;
            border-radius: 0 10px 10px 0;
        }
    }
    .table_box {
        padding-bottom: 60px;
        color: #333;
        tr {
            .c_line {
                background-color: #41CBAA;
            }
            .c_linec {
                background-color: #F08C00;
            }
            .c_line {
                background-color: #E7A53C;
            }

            th {
                color: #fff;
                font-size: 16px;
                background-color: #41CBAA;
                border: 1px solid #fff;
                width: 36px;
                height: 137px;
                text-align: center;
                border-radius: 6px;
            }
            .th_1 {
                background-color: #1CA4B6;
            }
            .th_2 {
                background-color: #AACF00;
            }
            .th_3 {
                background-color: #F6A724;
            }
            td {
                font-size: 14px;
                height: 84px;
                text-align: center;
                background-color: #F7F7F7;
                border: 1px solid #fff;
                .title {
                    margin-bottom: 10px;
                }
                .detail {
                    color: #F6A724;
                    font-size: 18px;
                    font-weight: bold;
                    padding-bottom: 30px;
                }

            }
            .titleBox {
                padding-left: 26px;
                text-align: left;
            }
            .td_score_box{
                width: 480px;
                padding: 0 20px;
                padding-bottom: 20px;
                .title {
                    text-align: left;
                    margin-bottom: 50px;
                }
            }
        }
    }
    .page_title_2 {
        .arrow {
            border-left: 14px solid #FEAE3B;
        }
    }
    .page_part5_result {
        padding-top: 120px;
        position: relative;
        .circle_box {
            background: url(~@/assets/report2_imgs/icon_xxdl_orange.png) no-repeat center center;
            .topBox {
                height: 200px;
            }
            .middleBox {
                .norm_box {
                    .norm {
                        .score {
                            background-color: #FEAE3B;
                            color: #FEAE3B;
                            font-size: 12px;
                        }
                    }
                }
                .norm_qinggan {
                    transform: rotate(-90deg);
                    .score {
                        transform: rotate(90deg);
                    }
                }
                .norm_renzhi {
                    transform: rotate(-151deg);
                    .score {
                        transform: rotate(151deg);
                    }
                }
                .norm_xingwei {
                    transform: rotate(-30deg);
                    .score {
                        transform: rotate(28deg);
                    }
                }
            }
            .bottomBox {
                padding-top: 34px;
                text-align: center;
                color: #fff;
                .title {
                    line-height: 42px;
                    margin-bottom: 15px;
                    font-size: 30px;
                }
                .score {
                    line-height: 28px;
                    font-size: 20px;
                }
            }
        }
        .detail_box {
            line-height: 28px;
            color: #8a8a8a;
            font-size: 14px;
            position: absolute;
            .title {
                font-size: 15px;
                font-weight: bold;
                color: #333;
                display: flex;
                align-items: center;
                margin-left: -10px;
                span {
                    width: 6px;
                    height: 6px;
                    background-color: #FEAE3B;
                    margin-right: 5px;
                    border-radius: 2px;
                }
            }
            .score {
                color: #333;
                line-height: 20px;
                span {
                    color: #333;
                }
            }
            .norm {
                span {
                    color: #50CFB1;
                }
            }
        }
        .detail_box0 {
            left: 40px;
            top: 226px;
        }
        .detail_box1 {
            left: 325px;
            top: 40px;
        }
        .detail_box2 {
            left: 600px;
            top: 226px;
        }
        .detail_box3 {
            left: 300px;
            top: 280px;
            z-index: 3;
            text-align: center;
            .title {
                font-size: 16px;
                margin-left: 0;
                text-align: center;
                justify-content: center;
            }
        }
    }
    .fenxi_box {
        padding: 35px 25px 25px 25px;
        background: #F6F6F6;
        border-radius: 6px;
        position: relative;
        margin-top: 60px;
        .f_title {
            width: 90px;
            height: 30px;
            line-height: 30px;
            border-radius: 6px;
            text-align: center;
            font-size: 16px;
            position: absolute;
            left: 25px;
            top: -15px;
            color: #fff;
            font-weight: bold;
        }
        .main {
            margin-bottom: 16px;
            &:last-child {
                margin-bottom: 0;
            }
            p {
                line-height: 25px;
                color: #969696;
                font-size: 14px;
            }
            .title {
                color: #303030;
                font-size: 16px;
            }
            .advise {
                padding-left: 10px;
                position: relative;
                margin-bottom: 10px;
                color: #333;
                &:before {
                    content: '';
                    position: absolute;
                    width: 4px;
                    height: 4px;
                    border-radius: 2px;
                    background-color: #AACF00;
                    top: 11px;
                    left: 0;
                }

            }

        }
    }
    .lis_score_box {
        padding-bottom: 60px;
        .lis_score {
            li {
                display: flex;
                height: 50px;
                .name {
                    padding-right: 16px;
                    text-align: right;
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 50px;
                    border-right: 1px solid #E0DEDE;
                    flex: 1;
                }
                .li_score_box {
                    padding: 15px 0;
                    height: 20px;
                    width: 600px;
                    .box {
                        height: 20px;
                        background-color: #F6F6F6;
                        position: relative;
                        .score_comment {
                            position: absolute;
                            top: 0;
                            line-height: 20px;
                            color: #fff;
                            z-index: 10;
                        }

                        .comment {
                            height: 20px;
                            position: absolute;
                            top: 0;
                            line-height: 20px;
                            color: #fff;
                            z-index: 10;
                            span {
                                display: inline-block;
                                margin-right: 15px;
                                font-size: 14px;
                                font-weight: bold;
                            }
                        }
                        .score {
                            text-align: right;
                            height: 20px;
                            line-height: 20px;
                            box-sizing: border-box;
                            padding-right: 5px;
                            color: #fff;
                            font-size: 14px;
                            position: relative;
                            p {

                            }

                        }
                        .norm {
                            position: absolute;
                            height: 20px;
                            top: 0;
                            background: rgba(121, 119, 119, 0.55);
                            opacity: 0.59;
                        }
                    }
                }
            }
        }
        .rule_box {
            display: flex;
            .name {
                flex: 1;
                height: 10px;
                border-right: 1px solid #E0DEDE;
                position: relative;
                span {
                    position: absolute;
                    width: 10px;
                    height: 20px;
                    line-height: 20px;
                    right: -5px;
                    bottom: -30px;
                    font-size: 12px;
                }
            }
            .rule {
                width: 600px;
                display: flex;

                li {
                    flex: 1;
                    height: 10px;
                    border-bottom: 1px solid #E0DEDE;
                    border-right: 1px solid #E0DEDE;
                    position: relative;
                    span {
                        position: absolute;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        right: -10px;
                        bottom: -30px;
                        font-size: 12px;
                        text-align: center;
                    }
                }
            }
        }
    }
}
</style>
